import { NAMESPACE } from './constants';


export const COMMAND_SELECT = `${NAMESPACE}/COMMAND_SELECT`;
export const COMMAND_ICON_SELECT = `${NAMESPACE}/COMMAND_ICON_SELECT`;
export const UPDATE_ACTIVE_COMMAND = `${NAMESPACE}/UPDATE_ACTIVE_COMMAND`;
export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const ASSETS_EXPIRED = `${NAMESPACE}/ASSETS_EXPIRED`;
